<form class="p-3 mb-0 h-100" (ngSubmit)="$event.preventDefault()">
  <xm-loader [showLoader]="loading$ | async"></xm-loader>

  <div class="d-flex justify-content-between block-sidebar-right-header">

    <h4 *ngIf="editType === EditType.Create" class="pt-2">{{ TRS.createDashboard | translate }}</h4>
    <h4 *ngIf="editType === EditType.Edit" class="pt-2">{{ TRS.editDashboard | translate }}</h4>

    <div class="d-flex flex-grow-1 ps-3 header-controls">

      <button (click)="onAdd()"
              *ngIf="editType === EditType.Create"
              [disabled]="!valid || disabled"
              color="primary"
              mat-flat-button>
        <mat-icon>create</mat-icon>
        {{ TRS.create | translate }}
      </button>

      <button (click)="onSave()"
              *ngIf="editType === EditType.Edit"
              [disabled]="!valid || disabled"
              [matTooltip]="(TRS.save | translate) + ' Ctrl+S'"
              color="primary"
              mat-icon-button>
        <mat-icon>save</mat-icon>
      </button>

      <button (click)="onDuplicate()"
              *ngIf="editType === EditType.Edit"
              [disabled]="!valid || disabled"
              [matTooltip]="TRS.duplicate | translate"
              mat-icon-button>
        <mat-icon>file_copy</mat-icon>
      </button>

      <button (click)="onDelete()"
              *ngIf="editType === EditType.Edit"
              [disabled]="!valid || disabled"
              [matTooltip]="TRS.delete | translate: { value: value.name }"
              mat-icon-button>
        <mat-icon>delete_outline</mat-icon>
      </button>

      <a [routerLink]="'/dashboard/admin-pages'" mat-icon-button>
        <mat-icon>open_in_new</mat-icon>
      </a>

      <div class="ms-auto">
        <button *ngIf="editType === EditType.Edit"
                [disabled]="!valid || disabled"
                [matTooltip]="TRS.copyClipboard | translate"
                mat-icon-button
                [xmCopy]="{
                  data: getData(),
                }"
        >
          <mat-icon>content_copy</mat-icon>
        </button>

        <button *ngIf="editType === EditType.Create"
                [disabled]="disabled"
                [matTooltip]="TRS.paste | translate"
                mat-icon-button
                [xmPaste]="{
                  data: value,
                }"
                (eventValue)="eventValue($event)"
        >
          <mat-icon>content_paste</mat-icon>
        </button>

        <button (click)="onCancel()"
                [matTooltip]="TRS.cancel | translate"
                mat-icon-button>
          <mat-icon>cancel</mat-icon>
        </button>
      </div>

    </div>

  </div>

  <div class="section-scroll">
    <div class="pb-3">
      <div *ngIf="value.id">{{ TRS.id | translate }}: <span class="fw-bold">{{ value.id }}</span></div>
      <div *ngIf="value.owner">{{ TRS.owner | translate }}: <span class="fw-bold">{{ value.owner }}</span>
      </div>
    </div>

    <xm-text-control [control]="nameControl"
                     [disabled]="disabled"
                     [config]="nameOptions"
                     name="name"></xm-text-control>

    <xm-text-control [control]="typeKeyControl"
                     [disabled]="disabled"
                     [config]="typeKeyOptions"
                     name="typeKey"></xm-text-control>

    <mat-tab-group>

      <mat-tab [label]="TRS.widgets | translate">
        <xm-dashboards-list-expand
          [dashboardId]="value.id"
          [widgetEditComponentType]="widgetEditComponentType"
          [dashboardWidgets]="dashboardWidgets"
        >
        </xm-dashboards-list-expand>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <div class="d-flex align-items-center gap-5">
            <span> {{TRS.config | translate}} </span>
            <xm-configuration-history [historyEvents]="configHistoryEvents" [config]="{itemType: 'dashboard', itemName: value?.name, changesType: 'config'}"></xm-configuration-history>
          </div>
        </ng-template>
        <xm-ace-editor-control [formControl]="configControl"
                               [disabled]="disabled"
                               [config]="aceEditorOptions"
                               name="config">
        </xm-ace-editor-control>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <div class="d-flex align-items-center gap-5">
            <span> {{TRS.layout | translate}} </span>
            <xm-configuration-history [historyEvents]="layoutHistoryEvents" [config]="{itemType: 'dashboard', itemName: value?.name, changesType: 'layout'}"></xm-configuration-history>
          </div>
        </ng-template>
        <xm-ace-editor-control [formControl]="layoutControl"
                               [disabled]="disabled"
                               [config]="aceEditorOptions"
                               name="layout">
        </xm-ace-editor-control>
      </mat-tab>

    </mat-tab-group>
  </div>
</form>
